import { SidebarMenu, ExtraRoutes } from "@/config/page_route";

/**
 * 권한 체크 함수
 */
export const hasPermission = (
  route: any,
  userRole: string | null,
  userPermissions: string[],
  userType?: string
): boolean => {
  // user_type 체크
  if (route.user_type && route.user_type !== userType) {
    return false;
  }

  // SUPER_ADMIN은 모든 라우트 접근 가능
  if (userRole === "SUPER_ADMIN") {
    return true;
  }

  // ADMIN의 경우 권한이 아직 로드되지 않았으면 접근 차단
  if (
    userRole === "ADMIN" &&
    (!userPermissions || userPermissions.length === 0)
  ) {
    return false;
  }

  // role 체크 (SUPER_ADMIN이 아닌 경우)
  if (route.role) {
    // SUPER_ADMIN 전용 라우트는 접근 불가
    if (route.role === "SUPER_ADMIN") {
      return false;
    }
    // 다른 role은 해당 role과 일치해야 함
    else if (route.role !== userRole) {
      return false;
    }
  }

  // ADMIN의 경우 permissions 체크
  if (userRole === "ADMIN") {
    // route에 permissions가 정의되어 있으면 체크
    if (route.permissions && route.permissions.length > 0) {
      return route.permissions.some((permission: string) =>
        userPermissions.includes(permission)
      );
    }
    // permissions가 정의되지 않은 경우 접근 허용
    return true;
  }

  return true;
};

/**
 * 첫 번째 접근 가능한 경로 찾기
 * 모든 메뉴를 평탄화하여 순서대로 확인하고 첫 번째 접근 가능한 경로를 반환
 */
export const getFirstAccessibleRoute = (
  userRole: string | null,
  userPermissions: string[],
  userType?: string
): string => {
  // SUPER_ADMIN은 관리자 관리 페이지로 이동
  if (userRole === "SUPER_ADMIN") {
    return "/admin/admin-list";
  }

  // 모든 접근 가능한 경로를 수집 (순서대로)
  const allRoutes: string[] = [];

  // SidebarMenu의 모든 자식 메뉴 경로 수집
  for (const menu of SidebarMenu) {
    if (hasPermission(menu, userRole, userPermissions, userType)) {
      if (menu.children && menu.children.length > 0) {
        for (const child of menu.children) {
          if (hasPermission(child, userRole, userPermissions, userType)) {
            allRoutes.push(child.path);
          }
        }
      } else {
        // 자식이 없으면 부모 경로 사용
        allRoutes.push(menu.path);
      }
    }
  }

  // ExtraRoutes의 모든 경로 수집
  for (const menu of ExtraRoutes) {
    if (hasPermission(menu, userRole, userPermissions, userType)) {
      allRoutes.push(menu.path);
    }
  }

  // 첫 번째 접근 가능한 경로 반환
  return allRoutes.length > 0 ? allRoutes[0] : "/admin/admin-list";
};
